import { Logger } from '@calendly/logging-service'

/** localStorage key distinguishing checkout vs payment-method-change PayPal confirms */
export const PAYPAL_PAYMENT_SESSION_FLOW_KEY = 'paypal_payment_session_flow'

export const PAYPAL_PAYMENT_SESSION_FLOWS = {
  CHECKOUT: 'checkout',
  PAYMENT_METHOD_CHANGE: 'payment_method_change'
}

export const getPaypalPaymentSessionFlow = () => {
  try {
    return localStorage.getItem(PAYPAL_PAYMENT_SESSION_FLOW_KEY)
  } catch (error) {
    Logger.warn('Failed to read PayPal payment session flow from localStorage', {
      error: error.message
    })
    return null
  }
}

export const isPaymentMethodChangeFlow = (flow = getPaypalPaymentSessionFlow()) => (
  flow === PAYPAL_PAYMENT_SESSION_FLOWS.PAYMENT_METHOD_CHANGE
)

export const setPaypalPaymentSessionFlow = (flow) => {
  try {
    localStorage.setItem(PAYPAL_PAYMENT_SESSION_FLOW_KEY, flow)
  } catch (error) {
    Logger.warn('Failed to store PayPal payment session flow in localStorage', {
      error: error.message,
      flow
    })
  }
}

export const clearPaypalPaymentSessionFlow = () => {
  try {
    localStorage.removeItem(PAYPAL_PAYMENT_SESSION_FLOW_KEY)
  } catch (error) {
    Logger.warn('Failed to clear PayPal payment session flow from localStorage', {
      error: error.message
    })
  }
}
